module.exports = __webpack_public_path__ + "img/introduction_bg2.1470e2c1.png";